{
  "decrease": "Vähenda {fieldLabel}",
  "increase": "Suurenda {fieldLabel}",
  "numberField": "Numbri väli"
}
